/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

import type { ContentPreviewProps } from "./ContentPreviewProps";

import "./ContentPreview.scss";

const ContentPreview: FunctionComponent<ContentPreviewProps> = (
  props: ContentPreviewProps
): JSX.Element => {
  const { item } = props;

  const isMovie: boolean = item.contentType === "movie";
  const isEpisode: boolean = item.contentType === "episode";
  const isSports: boolean =
    item.contentType === "sports" || item.contentType === "gameEvent";

  const hasMovieYear: boolean =
    isMovie && item.movieYear !== undefined && item.movieYear > 0;
  const hasStarRating: boolean =
    isMovie && item.starRating !== undefined && item.starRating > 0;
  const hasEpisodeInfo: boolean =
    isEpisode &&
    item.seasonNumber !== undefined &&
    item.episodeNumber !== undefined;
  const hasGameTitle: boolean =
    isSports && item.gameTitle !== undefined && item.gameTitle !== "";
  const hasRatingBadge: boolean =
    item.ratingBadge !== undefined && item.ratingBadge !== "";

  return (
    <div className="content-preview">
      <h4 className="content-preview__title">{item.title}</h4>

      {item.categoryLabel !== "" && (
        <span className="content-preview__category">{item.categoryLabel}</span>
      )}

      <div className="content-preview__meta">
        {item.isLive && (
          <span className="content-preview__badge content-preview__badge--live">
            LIVE
          </span>
        )}

        {item.isNew !== undefined && item.isNew && (
          <span className="content-preview__badge content-preview__badge--new">
            NEW
          </span>
        )}

        {hasRatingBadge && (
          <span className="content-preview__content-rating">
            {item.ratingBadge}
          </span>
        )}

        {item.duration > 0 && (
          <span className="content-preview__duration">
            {Math.floor(item.duration / 60) + " min"}
          </span>
        )}

        {hasMovieYear && (
          <span className="content-preview__year">{item.movieYear}</span>
        )}

        {hasStarRating && (
          <span className="content-preview__rating">
            {"★ " + (item.starRating as number).toFixed(1)}
          </span>
        )}

        {hasEpisodeInfo && (
          <span className="content-preview__episode">
            {"S" +
              String(item.seasonNumber) +
              " E" +
              String(item.episodeNumber)}
          </span>
        )}

        {hasGameTitle && (
          <span className="content-preview__game-title">{item.gameTitle}</span>
        )}
      </div>

      {item.description !== "" && (
        <p className="content-preview__description">{item.description}</p>
      )}

      {item.providerName !== undefined && item.providerName !== "" && (
        <span className="content-preview__provider">{item.providerName}</span>
      )}
    </div>
  );
};

export default ContentPreview;
